export enum USER_GROUP_PORTALS {
  ADMIN = 'admin',
  EMPLOYEE = 'employee',
  GUEST = 'guest'
}
